
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  emits: ["modal-close"],
  components: {
    Carousel,
    Slide,
    Navigation
  },
  props: {
    imageList: {
      type: Array,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedImage: {
      type: Number,
      default: 0
    }
  },

  setup(props, { emit }) {
    const carouselElement = ref(null) as any;
    const isMouseDown = ref<boolean>(false);

    onMounted(() => {
      document.body.style.overflow = "hidden";

      if (carouselElement.value) {
        carouselElement.value.data.currentSlide.value = props.selectedImage;
      }
    });

    onUnmounted(() => {
      document.body.style.overflow = "";
    });

    function handleOutsideClick(event) {
      if (isMouseDown.value) {
        isMouseDown.value = false;
        return;
      }

      if (event.target.id === "outside-modal") emit("modal-close");
    }

    function handleMouseDown(event) {
      if (event.target.id === "outside-modal") return;
      isMouseDown.value = true;
    }

    return {
      handleOutsideClick,
      handleMouseDown,
      carouselElement,
      emit
    };
  }
});
